var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"minimize-sidebar btn btn-link btn-just-icon",on:{"click":_vm.minimizeSidebar}},[_c('i',{staticClass:"tim-icons icon-align-center visible-on-sidebar-regular"}),_c('i',{staticClass:"tim-icons icon-bullet-list-67 visible-on-sidebar-mini"})])
}
var staticRenderFns = []

export { render, staticRenderFns }